export default __webpack_public_path__ + "3bbdc306d98299530eb77b96d5db7ef4.png";